import React, { Component, Fragment } from "react";
import Axios from "axios";
import { connect } from "react-redux";
import { updateJsonData } from "../../redux/actions/updateJsonData";
import "../newswissfrenchtabview.css";
import PricesChFr from "./PricesSwissFR.json";
import { configuration } from "../../appConfig";
import Swal from "sweetalert2";
import Lightbox from "react-image-lightbox";
import { getSelectedPartnerId } from "../../redux/actions/duplicateVinPartnerId";
import { reportAuthorized } from "../../redux/actions/reportAuthorized";
const provideSheetMetal_percentage = 25;

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class SwissFrenchPriceTable_v2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      words: {},
      lang: "",
      data: [],
      fullData: {},
      dismantling: 0,
      preparation: 0,
      PricePerHour: 0,
      SpareParts: 0,
      SparePartDetails: "",
      CarTypeArr: [
        { label: "--Select--", value: 'custom', price: 0 },
        { label: "Small, Citycar", value: 'smallCityCar', price: 0 },
        { label: "Compact,Family", value: 'compactFamily', price: 0 },
        { label: "Luxury, 4 X 4", value: 'luxuryCar', price: 0 },
        { label: "SUV", value: 'suv', price: 0 },
      ],
      AssemblingPrices1: 0,
      AssemblingPrices2: 0,
      CarType: 'custom',
      DisassemblyReassemblyPart: 0,
      DisassemblyReassemblyReplace: 0,
      ShowAW: false,
      ShowPrice: false,
      ALUPercentage: 0,
      LAKPercentage: 0,
      transformedCarDetails: {},
      imageArr: [],
      imageArrDamage: [],
      currentImageIndex: 0,
      filteredImages: [],
      insuaranceProvider: {},
      isShowReplaceColumn: false,
    };
  }
  componentDidMount() {
    this.getData();
    this.getLang();
    this.getScanImages();
  }
  getScanImages = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    try {
      const response = await Axios.get(configuration.getScanImages, {
        params: {
          partnerId: partnerId,
          vin: selectedFile,
        },
      });

      if (response && response.data) {
        const { data } = response;
        const filterImages = (images, keyword) => {
          return images ? images.filter(image => image.includes(keyword)) : [];
        };

        const Left = [
          ...filterImages(data.LeftFrontFender || data.Left, "LeftFrontFender"),
          ...filterImages(data.LeftFrontDoor || data.Left, "LeftFrontDoor"),
          ...filterImages(data.LeftBackDoor || data.Left, "LeftBackDoor"),
          ...filterImages(data.LeftBackFender || data.Left, "LeftBackFender")
        ];

        const right = [
          ...filterImages(data.RightFrontFender || data.right, "RightFrontFender"),
          ...filterImages(data.RightFrontDoor || data.right, "RightFrontDoor"),
          ...filterImages(data.RightBackDoor || data.right, "RightBackDoor"),
          ...filterImages(data.RightBackFender || data.right, "RightBackFender")
        ];

        this.setState({
          imageArr: [
            ...data.Hood,
            ...data.Roof,
            ...data.RightRoofFrame,
            ...data.LeftRoofFrame,
            ...data.TrunkCover,
            ...data.Trunk,
            ...right,
            ...Left,
          ],
        });

        const LeftDamage = [
          ...filterImages(data.LeftFrontFender_damage, "LeftFrontFender"),
          ...filterImages(data.LeftFrontDoor_damage, "LeftFrontDoor"),
          ...filterImages(data.LeftBackDoor_damage, "LeftBackDoor"),
          ...filterImages(data.LeftBackFender_damage, "LeftBackFender")
        ];

        const rightDamage = [
          ...filterImages(data.RightFrontFender_damage, "RightFrontFender"),
          ...filterImages(data.RightFrontDoor_damage, "RightFrontDoor"),
          ...filterImages(data.RightBackDoor_damage, "RightBackDoor"),
          ...filterImages(data.RightBackFender_damage, "RightBackFender")
        ];

        this.setState({
          imageArrDamage: [
            ...data.Hood_damage,
            ...data.Roof_damage,
            ...data.RightRoofFrame_damage,
            ...data.LeftRoofFrame_damage,
            ...data.TrunkCover_damage,
            ...data.Trunk_damage,
            ...rightDamage,
            ...LeftDamage,


          ],
        });
      }
    } catch (error) {
      console.error("Error fetching scan images:", error);
    }
  };
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;
    let currentLang;
    if (lang === "fr") {
      currentLang = "fr-fr";
    } else {
      currentLang = lang;
    }
    return words[word] ? words[word][currentLang] : word;
  };
  componentWillReceiveProps(nextProps, prevState) {
    if (nextProps.jsonData) {
      this.setState({
        fullData: nextProps.jsonData,
      });
    }
    if (nextProps.lang !== prevState.lang) {
      this.setState({ lang: nextProps.lang });
    } else if (nextProps.Authorized !== prevState.Authorized) {
      prevState.fullData.Authorized = nextProps.Authorized;
      this.setState({
        Authorized: nextProps.Authorized,
      });
    } else return null;
  }
  getData = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    Axios.get(
      `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    ).then((r) => {
      if (r.data) {
        this.props.reportAuthorized({
          Authorized: r.data.Authorized,
          DATReportAuthorized: r.data.DATReportAuthorized,
          MiniReportAuthorized: r.data.MiniReportAuthorized,
          MiniReportAuthorized2: r.data.MiniReportAuthorized2,
          FullReportAuthorized: r.data.FullReportAuthorized,
          FullReportAuthorized2: r.data.FullReportAuthorized2,
          DetailedReportAuthorized: r.data.DetailedReportAuthorized,
          AmericanReportAuthorized: r.data.AmericanReportAuthorized,
        })
        if (r.data.Client != "") {
          this.getInsurenceClients()
        }
        let newStr = [];
        const arrDataAE = [
          //1
          {
            Part: "Hood",
            dataAE: ["Dämmung", "Gitter"],
            shortname: "Hood",
          },
          //2
          {
            Part: "Left Front Fender",
            dataAE: ["Scheinwerfer"],
          },
          //3
          {
            Part: "Left Front Door",
            dataAE: ["Schachtleiste", "Spiegel"],
            shortname: "LFD",
          },
          //4
          {
            Part: "Left Back Door",
            dataAE: ["Schachtleiste"],
            shortname: "LBD",
          },
          //5
          {
            Part: "Left Back Fender",
            dataAE: ["Rücklicht  I", "Rücklicht  a"],
            shortname: "LBF",
          },
          //6
          {
            Part: "Trunk",
            dataAE: ["Bremsleucht"],
            shortname: "TR",
          },
          //7
          {
            Part: "Trunk Cover",
            dataAE: ["Bremsleucht"],
            shortname: "TC",
          },
          //8 
          {
            Part: "Right Back Fender",
            dataAE: ["Rücklicht  I", "Rücklicht  a"],
            shortname: "RBF",
          },
          //9
          {
            Part: "Right Back Door",
            dataAE: ["Schachtleiste"],
            shortname: "RBD",
          },
          //10
          {
            Part: "Right Front Door",
            dataAE: ["Schachtleiste", "Spiegel"],
            shortname: "RFD",
          },
          //11
          {
            Part: "Right Front Fender",
            dataAE: ["Scheinwerfer"],
            shortname: "RFF",
          },
          //12
          {
            Part: "Roof",
            dataAE: ["Himmel", "Dämmung"],
            shortname: "Roof",
          },
          //13
          {
            Part: "Left Roof Frame",
            dataAE: ["Dachleiste", "Dachreling"],
            shortname: "LRF",
          },
          //14
          {
            Part: "Right Roof Frame",
            dataAE: ["Dachleiste", "Dachreling"],
            shortname: "RRF",
          },
          // ["Rucklicht", "Verkleidung", "Radhausschale", "Tank Einsatz"],
          // ["Rucklicht", "Verkleidung", "Radhausschale", "Tank Einsatz"],
          // ["Frontscheibe", "Rahmen", "StoBstange"],
        ];
        const arrDataErsetzenErsetzen = [
          //1 hood
          [
            "FogLightL", // 39
            "FogLightR", // 40
            "HeadlightL", // 41
            "HeadlightR", // 42
            "RadiatorGrille", // 43
            "HoodEmblem", // 44
            "CoverForPlenumChamberL", // 45
            "CoverForPlenumChamberR", // 46
            "WindshieldWiperL_ArmCap", // 47
            "WindshieldWiperR_ArmCap", // 48
            "Windshield", // 49
            "WindshieldDecorTrimL", // 50
            "WindshieldDecorTrimR", // 51
            "FrontBumper", // 89
            "HoodReplace", // 1
          ],
          //2 left front fender
          [
            "SideFenderTurnSignalRepeaterLampL", // 15
            "FenderTrimPlateFL", // 16
            "LeftFrontTyre", // 90
            "LeftFrontFenderReplace", // 2 
          ],
          //3 left front door
          [
            "SideViewMirrorL", // 18
            "SideMirrorRepeaterLampL", // 19
            "OuterUpperDoorWindowTrim_Crom_FL", // 20
            "UprightOuterDoorCover_PlateFL", // 21
            "OuterLowerDoorWindowSlotSeal_Crom_FL", // 22
            "SideWindowFL", // 23
            "DoorHandleFL", // 24
            "Rocker_RunningPanelFL_DecorStrip", // 25
            "LeftFrontDoorReplace", // 4
          ],
          //4 left back door
          [
            "UprightOuterDoorCover_PlateFirstOneBL", // 26
            "OuterUpperDoorWindowTrim_Crom_BL", // 27
            "UprightOuterDoorCover_PlateSecondOneBL", // 28
            "OuterLowerDoorWindowSlotSeal_Crom_BL", // 29
            "SideWindowBL", // 30
            "DoorHandleBL", // 31
            "Rocker_RunningPanelBL_DecorStrip", // 32
            "LeftBackDoorReplace", // 6 
          ],
          //5 left back fender
          [
            "QuarterWindowBL", // 33
            "QuarterWindowTrim_Crom_BL", // 34
            "FuelTankDoor", // 35
            "FenderTrimPlateBL", // 36
            "TailLightOuterL", // 37
            "RearWindshieldDecorTrimL", // 38
            "LeftBackTyre", // 91
            "LeftBackFenderReplace", // 8
          ],
          //6 trunk cover
          [
            "TrunckCover_Spoiler", // 58
            "HighMountStopLight", // 59
            "RearWindshield", // 60
            "WiperForRearWindshield_ArmCap", // 61
            "TrunkEmblem", // 62
            "Emblem", // 63
            "TailLightInnerL", // 64
            "TailLightInnerR", // 65
            "TrunkCoverReplace", // 11
          ],
          //7 trunk
          [
            "TrunckCover_Spoiler", // 58
            "HighMountStopLight", // 59
            "RearWindshield", // 60
            "WiperForRearWindshield_ArmCap", // 61
            "TrunkEmblem", // 62
            "Emblem", // 63
            "TailLightInnerL", // 64
            "TailLightInnerR", // 65
            "TrunkReplace", // 10
          ],
          //8 right back fender
          [
            "QuarterWindowBR", // 84
            "QuarterWindowTrim_Crom_BR", // 85
            "FenderTrimPlateBR", // 86
            "TailLightOuterR", // 87
            "RearWindshieldDecorTrimR", // 88
            "RightBackTyre", // 93
            "BackBumper", // 94
            "RightBackFenderReplace", // 9
          ],
          //9 right back door
          [
            "UprightOuterDoorCover_PlateFirstOneBR", // 77
            "OuterUpperDoorWindowTrim_Crom_BR", // 78
            "UprightOuterDoorCover_PlateSecondOneBR", // 79
            "OuterLowerDoorWindowSlotSeal_Crom_BR", // 80
            "SideWindowBR", // 81
            "DoorHandleBR", // 82
            "Rocker_RunningPanelBR_DecorStrip", // 83
            "RightBackDoorReplace", // 7
          ],
          //10 right front door
          [
            "SideViewMirrorR", // 69
            "SideMirrorRepeaterLampR", // 70
            "OuterUpperDoorWindowTrim_Crom_FR", // 71
            "UprightOuterDoorCover_PlateFR", // 72
            "OuterLowerDoorWindowSlotSeal_Crom_FR", // 73
            "SideWindowFR", // 74
            "DoorHandleFR", // 75
            "Rocker_RunningPanelFR_DecorStrip", // 76
            "RightFrontDoorReplace", // 5
          ],
          //11 right front fender
          [
            "SideFenderTurnSignalRepeaterLampR", // 66
            "FenderTrimPlateFR", // 67
            "RightFrontTyre", // 92
            "RightFrontFenderReplace", // 3
          ],
          //12 roof
          [
            "RoofDripMoldingL", // 52
            "RoofDripMoldingR", // 53
            "SunRoof", // 54
            "Antenna", // 57
            "RoofReplace", // 12
          ],
          //13 left roof frame
          [
            "DecorStickerOfRoofFrameL", // 17
            "RoofRailL", // 55
            "LeftRoofFrameReplace", //13
          ],
          //14 right roof frame
          [
            "RoofRailR", // 56
            "DecorStickerOfRoofFrameR", // 68
            "RightRoofFrameReplace", // 14
          ],
        ];
        r.data.Dents && r.data.Dents.map((dent, index) => {
          dent.arrErsetzen = arrDataErsetzenErsetzen[index];
        });

        if (r.data.Dents) {
          r.data.Dents.map((dent, index) => {
            dent.arrAE = arrDataAE[index];
            if (dent.AE) {
              dent.AE.forEach((value) => {
                newStr.push(`${value}[${dent.arrAE.shortname}]`);
              });
            }
          });
        }

        this.setState(
          {
            fullData: r.data,
            Client: r.data.Client,
            dismantling:
              r.data.Dismantling !== undefined && r.data.Dismantling >= 0
                ? r.data.Dismantling
                : 25,
            preparation:
              r.data.Preparation !== undefined || r.data.Preparation >= 0
                ? r.data.Preparation
                : 10,
            PricePerHour: parseInt(
              r.data.PricePerHour ? r.data.PricePerHour : 0
            ),
            //   (r.data.PricePerHour !== undefined &&
            //     r.data.PricePerHour.toFixed(2)) ||
            //   "",
            SpareParts:
              (r.data.SpareParts && parseInt(r.data.SpareParts).toFixed(2)) || 0,
            SparePartDetails: r.data.SparePartDetails || "",
            partsFromAE: newStr.toString(),
            UserEnteredSparePartsDetails:
              r.data.UserEnteredSparePartsDetails || "",
            AssemblingPrices1: r.data.AssemblingPrices1
              ? r.data.AssemblingPrices1
              : 0,
            AssemblingPrices2: r.data.AssemblingPrices2
              ? r.data.AssemblingPrices2
              : 0,
            DisassemblyReassemblyPart: r.data.DisassemblyReassemblyPart
              ? r.data.DisassemblyReassemblyPart
              : 0,
            DisassemblyReassemblyReplace: r.data.DisassemblyReassemblyReplace
              ? r.data.DisassemblyReassemblyReplace
              : 0,
            ShowPrice: r.data.hasOwnProperty('ShowPrice') ? r.data.ShowPrice : true,
            ShowAW: r.data.hasOwnProperty('ShowAW') ? r.data.ShowAW : false,
            CarType: this.findCarType(r.data),
          },
          () => {
            this.getFallbackDetails();
          }
        );
        this.setState({ data: r.data.Dents }, () => {
          this.updateReduxJson();
          if (this.state.data) {
            // for get AWa, AWb,AWc,AWd first time
            this.state.data.map((row, index) =>
              this.getOriginalAW(row, index)
            );
          }
        });
      }
    });
  };

  getInsurenceClients = async () => {
    const partnerId = localStorage.getItem("partnerId");

    if (partnerId) {
      const url = configuration.getInsurenceClients + "?partnerId=" + partnerId;
      const response = await Axios.post(url)
      if (response.data) {
        response.data.map((info) => {
          if (this.state.Client && this.state.Client != undefined && this.state.Client != "" && this.state.Client.toLocaleLowerCase() && this.state.Client.toLocaleLowerCase() == info.Name.toLocaleLowerCase()) {
            this.setState({ insuaranceProvider: info })
          }
        })
      }
    }
  };

  findCarType = (json) => {
    const { CarTypeArr } = this.state;
    if (json.hasOwnProperty('CarType')) {
      return json.CarType;
    } else {
      let keyName = !this.props.isUseBasePrice ? 'AssemblingPrices1' : 'AssemblingPrices2'
      let filteredArr = CarTypeArr.filter((o) => o.price === json[keyName])
      return filteredArr.length ? filteredArr[0].value : 'custom';
    }
  }

  getFallbackDetails = async () => {
    try {
      const url =
        configuration.getFallbackDetails +
        `?partner_id=${localStorage.getItem("partnerId")}`;
      const res = await Axios.get(url);
      if (res.data) {
        function hexToRgb(hex) {
          hex = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b);
          let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
          return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
          } : null;
        }

        let rgbColor = hexToRgb(this.state.insuaranceProvider.PrimaryColor || res.data.primary_color);
        let rgbaColor = `rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, 0.20)`;
        this.props.getSelectedPartnerId({
          duplicateSelectedPartnerId: res.data.vin_duplicate_partner_id.length > 0 ? res.data.vin_duplicate_partner_id : [],
          isDuplicateVin: res.data.is_vin_duplicate
        })
        this.setState({
          ALUPercentage: res.data.alu ? res.data.alu : 0,
          LAKPercentage: res.data.lak ? res.data.lak : 0,
          PrimaryColor: res.data.primary_color || "#FF0000",
          SecondaryColor: res.data.secondary_color || "#000000",
          PrimaryTextColor: res.data.primary_text_color || "#000000",
          SecondaryTextColor: res.data.secondary_text_color || "#fff",
          rgbaColor: rgbaColor,
          isShowReplaceColumn: parseInt(res.data.is_show_replace_column) === 1 ? true : false,
        });
        if (this.props.isUseBasePrice) {
          this.setState({
            PricePerHour: parseInt(res.data.basePrice) || 145,
          });
        } else if (!this.state.PricePerHour) {
          this.setState({
            PricePerHour: parseInt(res.data.PricePerHour) || 145,
          });
        }
        if (res.data.carDetails.length) {
          // this.priceSetInCarTypeArr(res.data.carDetails)
          this.carDetailsConvertInObj(res.data.carDetails)
        }
        this.updateReduxJson();
      }
    } catch (error) {
      this.setState({
        ALUPercentage: "",
        LAKPercentage: "",
      });
    }
  };

  carDetailsConvertInObj = (arr) => {
    const transformedCarDetails = {};
    arr.forEach(detail => {
      const { CarType, priceType, price } = detail;

      if (!transformedCarDetails[`price${priceType}`]) {
        transformedCarDetails[`price${priceType}`] = {};
      }

      transformedCarDetails[`price${priceType}`][CarType] = price;
    });
    this.setState({
      transformedCarDetails
    })
    // return transformedCarDetails
  }

  priceSetInCarTypeArr = (arr) => {
    // const { CarTypeArr } = this.state;
    // const { isUseBasePrice } = this.props;
    // CarTypeArr.map((obj,i) => {
    //   if(!isUseBasePrice) {
    //     arr.map((r) => {
    //       if(obj.value === r.CarType && parseInt(r.priceType) === 1) {
    //         CarTypeArr[i].price = r.price;
    //       }
    //     })
    //   } else {
    //     arr.map((r) => {
    //       if(obj.value === r.CarType && parseInt(r.priceType) === 2) {
    //         CarTypeArr[i].price = r.price;
    //       }
    //     })
    //   }
    // });
    // this.setState({
    //   CarTypeArr: [...CarTypeArr]
    // })
  }

  hadnleDentsChanges = async (e, index) => {
    const { data } = this.state;
    const { name, value } = e.target;
    data[index][name] = parseInt(value);
    data[index]["TotalDents"] =
      (data[index]["A"] ? data[index]["A"] : 0) +
      (data[index]["B"] ? data[index]["B"] : 0) +
      (data[index]["C"] ? data[index]["C"] : 0) +
      (data[index]["D"] ? data[index]["D"] : 0);
    this.getAW(data[index]);
    this.updateReduxJson();
    this.setState({
      data,
    });
  };
  // getAluLakAddedAW = (row, index) => {
  //   let originalAW = this.getOriginalAW(row.A, row.B, row.C, 0, index);
  //   let finalAW;

  //   //check if alu/lak is enabled or not
  //   const { ALUPercentage, LAKPercentage } = this.state;
  //   let aluPr = parseFloat(ALUPercentage);
  //   let lakPr = parseFloat(LAKPercentage);

  //   let incPR = 0;
  //   if (row.Alu && row.Push2paint) {
  //     //if Alu and lak both are enabled
  //     incPR = aluPr + lakPr;
  //   } else if (row.Alu) {
  //     //if only Alu is enabled
  //     incPR = aluPr;
  //   } else if (row.Push2paint) {
  //     //if only Push2paint is enabled
  //     incPR = lakPr;
  //   } else {
  //     //if only Push2paint is enabled
  //     incPR = 0;
  //   }

  //   if (incPR !== 0) {
  //     finalAW =
  //       0 || parseFloat(originalAW) + (parseFloat(originalAW) * incPR) / 100.0;
  //   } else {
  //     finalAW = originalAW;
  //   }
  //   return finalAW.toFixed(2);
  // };
  getOriginalAW = (row) => {
    row.AWa = null;
    row.AWb = null;
    row.AWc = null;
    row.AWd = null;
    row.AW = this.getAW(row);
  };
  getAW = (row) => {
    let originalAW = 0;
    if (!row.Replace || !row.Plastic) {
      const dentSize = (row.A ? row.A : 0) +
        2 * (row.B ? row.B : 0) +
        3 * (row.C ? row.C : 0) +
        6 * (row.D ? row.D : 0);
      PricesChFr.map((obj) => {
        if (obj.dents.min <= dentSize && obj.dents.max >= dentSize) {
          originalAW = obj.AWa;
        } else if (dentSize > 600) {
          originalAW = 186;
        }
      });
    };
    row["AW"] = originalAW;
    return originalAW;
  };
  handleAluLakChanges = (e, index, key) => {
    const { data } = this.state;
    data[index][key] = e.target.checked;

    // for updating AW in json
    // data[index]["AW"] = this.getAluLakAddedAW(data[index], index);
    this.setState({ data }, () => {
      this.props.getUpdatedStateFromPriceTable(this.state.fullData);
      this.updateReduxJson();
      // this.saveChanges();
    });
  };

  getTotalUT = (row, index) => {
    let total = row.Plastic ? 0 : this.getAW(row);
    const { ALUPercentage, LAKPercentage } = this.state;
    let aluPr = parseFloat(ALUPercentage);
    let lakPr = parseFloat(LAKPercentage);
    let provideSteelMetalPr = parseFloat(provideSheetMetal_percentage);
    let incPR = 0;
    if (row.Alu && row.Push2paint && row.ProvideSheetMetal) {
      incPR = aluPr + lakPr + provideSteelMetalPr;
    } else if (row.Alu && row.Push2paint) {
      incPR = aluPr + lakPr;
    } else if (row.Push2paint && row.ProvideSheetMetal) {
      incPR = lakPr + provideSteelMetalPr;
    } else if (row.ProvideSheetMetal && row.Alu) {
      incPR = provideSteelMetalPr + aluPr;
    } else if (row.Alu) {
      incPR = aluPr;
    } else if (row.Push2paint) {
      incPR = lakPr;
    } else if (row.ProvideSheetMetal) {
      incPR = provideSteelMetalPr;
    } else {
      incPR = 0;
    }

    if (incPR !== 0) {
      total = 0 || parseFloat(total) + (parseFloat(total) * incPR) / 100.0;
    } else {
      total = total;
    }

    return total ? total : 0;
  };
  getAmount = (row, index, applyFormate) => {
    var Amount = isNaN(this.getTotalUT(row, index))
      ? 0
      : row.Plastic ? 0 : this.getTotalUT(row, index) * this.state.PricePerHour * 0.1;
    if (applyFormate) {
      Amount = Intl.NumberFormat("it-CH", {
        currency: "CHF",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Amount.toFixed(2));
      Amount = Amount.replace(".", ",");
    }
    return Amount;
  };
  getTotalAw = () => {
    const { data } = this.state;
    const total =
      data &&
      data.reduce((acc, num, i) => {
        if (
          num.Part !== "LeftFrontTyre" &&
          num.Part !== "LeftBackTyre" &&
          num.Part !== "RightFrontTyre" &&
          num.Part !== "RightBackTyre" &&
          num.Part !== "FrontBumper" &&
          num.Part !== "BackBumper" &&
          num.Part !== "Underbody" &&
          num.Part !== "Inside"
        ) {
          return parseFloat(acc) + parseFloat(this.getAluLakAddedAW(num, i));
        } else {
          return parseFloat(acc);
        }
      }, 0);
    return Number(total);
  };
  getTotalAmount = (applyFormate) => {
    const { data } = this.state;
    let totalAmount =
      data &&
      data.reduce((acc, num, i) => {
        if (
          num.Part !== "LeftFrontTyre" &&
          num.Part !== "LeftBackTyre" &&
          num.Part !== "RightFrontTyre" &&
          num.Part !== "RightBackTyre" &&
          num.Part !== "FrontBumper" &&
          num.Part !== "BackBumper" &&
          num.Part !== "Underbody" &&
          num.Part !== "Inside"
        ) {
          return parseFloat(acc) + this.getAmount(num, i, false);
        } else {
          return parseFloat(acc);
        }
      }, 0);
    if (applyFormate) {
      totalAmount = Intl.NumberFormat("it-CH", {
        currency: "CHF",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(totalAmount.toFixed(2));
      totalAmount = totalAmount.replace(".", ",");
    }
    return totalAmount;
  };

  getParticularTotalDents = (row) => {
    const totalDents = row.A + row.B + row.C + row.D;
    return totalDents ? totalDents : 0;
  };

  getTotalRepairCost = (applyFormate) => {
    const { isUseBasePrice } = this.props;
    const {
      AssemblingPrices1,
      AssemblingPrices2,
      DisassemblyReassemblyPart,
      DisassemblyReassemblyReplace,
    } = this.state;
    let repairCost =
      parseFloat(this.getTotalAmount(false)) +
      parseFloat((!isUseBasePrice ? AssemblingPrices1 : AssemblingPrices2) || 0) +
      parseFloat(DisassemblyReassemblyPart) +
      this.getTotalDisassemblyReassemblyReplace()
    // parseFloat(DisassemblyReassemblyReplace);
    if (applyFormate) {
      repairCost = Intl.NumberFormat("it-CH", {
        currency: "CHF",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(repairCost.toFixed(2));
      repairCost = repairCost.replace(".", ",");
    }
    return repairCost;
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    if (!value && name !== "UserEnteredSparePartsDetails") {
      this.setState(
        {
          [name]: 0,
        },
        () => {
          this.updateReduxJson();
        }
      );
    } else if (name === 'customAssemblingPrices') {
      this.setState(
        {
          AssemblingPrices1: value,
          AssemblingPrices2: value,
        },
        async () => {
          this.updateReduxJson();
        }
      );
    } else {
      this.setState(
        {
          [name]: value,
        },
        async () => {
          (name === 'CarType') && await this.getAssemblingPrices();
          this.updateReduxJson();
        }
      );
    }
  };

  getAssemblingPrices = () => {
    const { CarType, CarTypeArr, transformedCarDetails } = this.state;
    // const assemblingPrices = CarTypeArr.filter((o) => o.value === CarType);
    this.setState({
      // assemblingPrices: assemblingPrices.length ? assemblingPrices[0].price : 0, 
      AssemblingPrices1: transformedCarDetails && transformedCarDetails.price1 && transformedCarDetails.price1[CarType] ? transformedCarDetails.price1[CarType] : 0,
      AssemblingPrices2: transformedCarDetails && transformedCarDetails.price2 && transformedCarDetails.price2[CarType] ? transformedCarDetails.price2[CarType] : 0,
    })
  }

  updateReduxJson = () => {
    const {
      fullData,
      data,
      AssemblingPrices1,
      AssemblingPrices2,
      DisassemblyReassemblyPart,
      DisassemblyReassemblyReplace,
      CarType
    } = this.state;
    fullData.PricePerHour = parseFloat(
      parseFloat(this.state.PricePerHour).toFixed(2)
    );
    fullData.AssemblingPrices1 = parseFloat(AssemblingPrices1);
    fullData.AssemblingPrices2 = parseFloat(AssemblingPrices2);
    fullData.CarType = CarType;
    fullData.DisassemblyReassemblyPart = parseFloat(DisassemblyReassemblyPart);
    fullData.DisassemblyReassemblyReplace = parseFloat(DisassemblyReassemblyReplace);
    fullData.Amount = this.getTotalRepairCost()
    fullData.TotalDentCount = this.getTotalDents();

    if (this.state.partsFromAE.length > 0) {
      if (this.state.UserEnteredSparePartsDetails.length > 0) {
        fullData.SparePartDetails =
          this.state.UserEnteredSparePartsDetails +
          "," +
          " " +
          this.state.partsFromAE;
      } else {
        fullData.SparePartDetails = this.state.partsFromAE;
      }
    } else {
      fullData.SparePartDetails = this.state.UserEnteredSparePartsDetails;
    }
    fullData.UserEnteredSparePartsDetails =
      this.state.UserEnteredSparePartsDetails;
    //for updating the AW in json
    if (data) {
      data.forEach((row, index) => {
        row.AW =
          parseFloat(this.getTotalUT(row, index)) +
          parseFloat(row.AWd ? row.AWd : 0);
        delete row.ProvidePaint;
      });
    }
    this.setState({ data, fullData });
    this.props.updateJsonData(this.state.fullData);
  };
  handleSave = () => {
    // const changes = this.state.changedB || this.state.changedA;
    const { fullData, data } = this.state;
    if (!!fullData) {
      fullData.PricePerHour = parseFloat(
        parseFloat(this.state.PricePerHour).toFixed(2)
      );
      // fullData.totalDents = this.getTotalDents();
      if (this.state.partsFromAE.length > 0) {
        if (this.state.UserEnteredSparePartsDetails.length > 0) {
          fullData.SparePartDetails =
            this.state.UserEnteredSparePartsDetails +
            "," +
            " " +
            this.state.partsFromAE;
        } else {
          fullData.SparePartDetails = this.state.partsFromAE;
        }
      } else {
        fullData.SparePartDetails = this.state.UserEnteredSparePartsDetails;
      }

      fullData.UserEnteredSparePartsDetails =
        this.state.UserEnteredSparePartsDetails;
      //for updating the AW in json
      // data.forEach((row) => {
      //   row.AW = this.getAluLakAddedAW(row);
      // });
      fullData.Dents.forEach((part) => {
        if (part.Plastic) {
          part.A = 0;
          part.B = 0;
          part.C = 0;
          part.D = 0;
          part.AW = 0;
          part.NonHailDamagePresent = false;
          part.Alu = false;
          part.Push2paint = false;
          part.ProvideSheetMetal = false;
          part.disassemble = false;
          part.ReserveFeasibility = false;
          part.Replace = false;
          part.TotalDents = 0;
          part.TotalDamages = 0;
        }
      });
      this.setState({ data, fullData }, () => {
        this.saveChanges();
      });
    }
  };
  saveChanges = () => {
    const { fullData } = this.state;
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    let payload = {
      ...this.state.fullData,
      ShowPrice: this.state.ShowPrice,
      ShowAW: this.state.ShowAW,
      IsPriceTableUpdated: true,
      PartnerID: partnerId
      // CarType
    };
    this.props.getUpdatedStateFromPriceTable(false);
    this.props.updateJsonData(payload);
    const url =
      configuration.PostEditorChanges +
      `?partnerId=${localStorage.getItem(
        "partnerId"
      )}&vin=${localStorage.getItem("selectedFile")}&TabViewUpdated=${!fullData.TabViewUpdated}`;

    Axios.post(url, payload)
      .then((res) => {
        Toast.fire({
          type: "success",
          title: "Data saved successfully",
        });
        this.getScanImages()
        this.props.getUpdatedStateFromPriceTable(true);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something went wrong",
        });
      });
  };
  plasticChange = (part, e, index, key) => {
    const { name } = e.target;
    const { data } = this.state;

    data[index][key] = e.target.checked;
    this.setState({ data }, () => {
      // this.handleSave()
    });
  };
  getTotalDents = () => {
    const { Dents } = this.state.fullData;
    let totalDents =
      Dents &&
      Dents.reduce((acc, num) => {
        if (
          num.Part !== "LeftFrontTyre" &&
          num.Part !== "LeftBackTyre" &&
          num.Part !== "RightFrontTyre" &&
          num.Part !== "RightBackTyre" &&
          num.Part !== "FrontBumper" &&
          num.Part !== "BackBumper" &&
          num.Part !== "Underbody" &&
          num.Part !== "Inside"
        ) {
          return (
            parseInt(acc) +
            (parseInt(num.A) ? num.Plastic ? 0 : parseInt(num.A) : 0) +
            (parseInt(num.B) ? num.Plastic ? 0 : parseInt(num.B) : 0) +
            (parseInt(num.C) ? num.Plastic ? 0 : parseInt(num.C) : 0) +
            (parseInt(num.D) ? num.Plastic ? 0 : parseInt(num.D) : 0)
          );
        } else {
          return parseInt(acc);
        }
      }, 0);
    return totalDents;
  };
  totalUT = () => {
    const { Dents } = this.state.fullData;
    // let HG = 0;
    let totalUT =
      Dents &&
      Dents.reduce((acc, num, i) => {
        if (
          num.Part !== "LeftFrontTyre" &&
          num.Part !== "LeftBackTyre" &&
          num.Part !== "RightFrontTyre" &&
          num.Part !== "RightBackTyre" &&
          num.Part !== "FrontBumper" &&
          num.Part !== "BackBumper" &&
          num.Part !== "Underbody" &&
          num.Part !== "Inside"
        ) {
          // HG = HG + (num.AWd ? num.AWd : 0);
          return parseInt(acc) + this.getTotalUT(num, i);
        } else {
          return parseInt(acc);
        }
      }, 0);
    // return `${totalUT}(+${HG} HG)`;
    return totalUT;
  };
  changeAE = (event, index, value, key) => {
    const { data, fullData } = this.state;
    const aeArr = Array.isArray(data[index]["AE"]) ? data[index]["AE"] : [];
    if (event.target.checked) {
      aeArr.push(`${value}`);
    } else {
      aeArr.map((val, idx) => {
        if (value == val) {
          aeArr.splice(idx, 1);
        }
      });
    }
    data[index]["AE"] = aeArr;

    let newStr = [];
    data.forEach((row) => {
      if (row.AE) {
        // newStr.push(...row.AE)
        row.AE.forEach((value) => {
          newStr.push(`${value}[${row.arrAE.shortname}]`);
        });
      }
    });
    this.setState({ data, partsFromAE: newStr.toString() }, () => {
      if (this.state.partsFromAE.length > 0) {
        if (this.state.UserEnteredSparePartsDetails.length > 0) {
          fullData.SparePartDetails =
            this.state.UserEnteredSparePartsDetails +
            "," +
            " " +
            this.state.partsFromAE;
        } else {
          fullData.SparePartDetails = this.state.partsFromAE;
        }
      } else {
        fullData.SparePartDetails = this.state.UserEnteredSparePartsDetails;
      }
      fullData.UserEnteredSparePartsDetails =
        this.state.UserEnteredSparePartsDetails;
      this.setState({ fullData }, () => {
        // this.saveChanges();
      });
    });
  };
  handleToggle = (e) => {
    const name = e.target.name;
    const value = e.target.checked;
    this.setState({
      [name]: value,
    }, () => {
      this.saveChanges()
    });
  };

  // toggle = (partName, showImg, isPlastic) => {
  //   if (showImg) {
  //     const imageArr = this.state.imageArr && this.state.imageArr.length > 0 && this.state.imageArr.filter((image) => {
  //       const spiltUrl = image.split("/")[6];
  //       const part = isPlastic
  //         ? spiltUrl && spiltUrl.split("_")[0]
  //         : spiltUrl && spiltUrl.split("_")[1];
  //       return part === partName;
  //     });
  //     this.setState({
  //       modal: !this.state.modal,
  //       imgPartName: partName,
  //       currentImageIndex: 0,
  //       filteredImages: imageArr, 
  //     });
  //   } else {
  //     this.setState({
  //       modal: !this.state.modal,
  //     });
  //   }
  // };

  toggle = (partName, showImg, isPlastic) => {
    if (showImg) {
      const images = (configuration.imagePath == "https://backend.drivenscan.live" && this.props.toggleReportDamageImage) ? this.state.imageArrDamage : this.state.imageArr;
      const imageArr = images && images.length > 0 && images.filter((image) => {
        const spiltUrl = image.split("/")[(configuration.imagePath == "https://backend.drivenscan.live" && this.props.toggleReportDamageImage) ? 7 : 6];
        const reportInclude = spiltUrl && spiltUrl.includes("Report")
        const part = reportInclude ? spiltUrl && spiltUrl.split("_")[1] : spiltUrl && spiltUrl.split("_")[0];
        return part === partName;
      });
      this.setState({
        modal: !this.state.modal,
        imgPartName: partName,
        currentImageIndex: 0,
        filteredImages: imageArr,
      });
    } else {
      this.setState({
        modal: !this.state.modal,
      });
    }
  };

  getCarOption = () => {
    const { CarTypeArr, CarType } = this.state
    let carTypeLabel = CarTypeArr.map((car) => {
      if (car.value === CarType) {
        return (car.label)
      } else {
        return ''
      }
    })
    return carTypeLabel;
  }

  getTotalDisassemblyReassemblyReplace = (isApplyFormate) => {
    const { data } = this.state;
    let totalDisassemblyReassemblyReplacePrice = 0;
    data && data.map((row, i) => {
      if (row.disassemble && !row.Plastic) {
        totalDisassemblyReassemblyReplacePrice += 50;
      }
    })
    if (isApplyFormate) {
      return Intl.NumberFormat("it-CH", { currency: "CHF", minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(totalDisassemblyReassemblyReplacePrice.toFixed(2)).replace(".", ",")
    }
    return totalDisassemblyReassemblyReplacePrice;
  };

  changeErsetzen = (event, index, value, key) => {
    const { data } = this.state;
    const totalDents = data[index].TotalDents;
    const ersetzenArr = Array.isArray(data[index]["Ersetzen"])
      ? data[index]["Ersetzen"]
      : [];

    if (event.target.checked) {
      // if (key === "Ersetzen") {
      ersetzenArr.push(`${value}`);
      // data[index]["Ersetzen"] = [];
      // }
    } else {
      ersetzenArr.map((val, indx) => {
        if (value == val) {
          ersetzenArr.splice(indx, 1);
        }
      });
    }

    data[index]["Ersetzen"] = ersetzenArr;
    this.setState({ data });
  };

  render() {
    const partnerId = window.localStorage.getItem("partnerId")
    const dynamic_Table_Colors = {
      '--table-even-color': this.state.rgbaColor || '#E8F3FF',
      '--table-header-color': this.state.insuaranceProvider.PrimaryColor || this.state.PrimaryColor || '#D80707',
      '--table-footer-color': this.state.insuaranceProvider.SecondaryColor || this.state.SecondaryColor || '#000',
      '--table-header-text-color': this.state.insuaranceProvider.HeaderTextColor || this.state.PrimaryTextColor || '#000',
      '--table-footer-text-color': this.state.insuaranceProvider.FooterTextColor || this.state.SecondaryTextColor || '#fff',
    };
    const { viewType, Authorized, isUseBasePrice } = this.props;
    const path = window.location.pathname
    const {
      data,
      PricePerHour,
      CarTypeArr,
      CarType,
      AssemblingPrices1,
      AssemblingPrices2,
      DisassemblyReassemblyPart,
      DisassemblyReassemblyReplace,
      ShowAW,
      ShowPrice,
      LAKPercentage,
      ALUPercentage,
      modal,
      isShowReplaceColumn
    } = this.state;
    let colSpan = ShowAW ? path == "/TabViewSwissFrench" ? 18 : 16 : 14;
    colSpan = (viewType === 'TabView' && isShowReplaceColumn) ? colSpan - 0 : ShowAW ? colSpan - 2 : colSpan - 2;
    return (
      <>
        <div className={`all-price-table-wrapper new_swiss_french_table ${this.props.viewType === "TabView" ? 'container-fluid ' : 'container'} `}>
          <div className="row french-title-row">
            <div className="col-12 p-0">
              <div className="row p-0">
                <div className="col-lg-4 col-md-8 col-sm-12 col-12 p-0">
                  <h3 className="report-title">{this.lang("Damage Description")} </h3>
                </div>
                {this.props.viewType === "TabView" && (
                  <div className="col-lg-8 col-md-8 col-sm-12 text-right p-0 end-position-btn">
                    <div className="d-flex align-items-center justify-content-end">
                      <div className="admin-list mx-2">
                        <label className="name pr-2">{this.lang("showUT")}</label>
                        <div className="switch-button switch-button-lg">
                          {viewType === 'TabView' ? (
                            <input
                              type="checkbox"
                              name="ShowAW"
                              id="ShowAW"
                              value={ShowAW}
                              onClick={(e) => this.handleToggle(e)}
                              checked={ShowAW}
                              disabled={Authorized}
                            />
                          ) : (
                            <p></p>
                          )}
                          <span>
                            <label for="ShowAW"></label>
                          </span>
                        </div>
                      </div>
                      <div className="admin-list mx-2">
                        <label className="name pr-2">{this.lang("ShowPrice")}</label>
                        <div className="switch-button switch-button-lg">
                          <input
                            type="checkbox"
                            name="ShowPrice"
                            id="ShowPrice"
                            onClick={(e) => this.handleToggle(e)}
                            checked={ShowPrice}
                            disabled={Authorized}
                          />
                          <span>
                            <label for="ShowPrice"></label>
                          </span>
                        </div>
                      </div>
                      <button
                        //  className='SubmitBut'
                        id="updateTable"
                        style={{
                          // padding:'5px',
                          backgroundColor: "#F20000",
                          padding: "5px 10px",
                          color: "white",
                          border: "none",
                          borderRadius: "5px",
                          fontSize: "16px",
                        }}
                        disabled={Authorized}
                        onClick={this.handleSave}
                      >
                        {this.lang("Update Table")}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {!this.props.is_extra_columns_visible_mini_fullreport &&
            <div className={`row dns-rice-table-row  ${this.props.viewType === "TabView" ? "arrow_table_main_wrapper" : ""}`}>
              <div className="col-12 table-responsive">
                <table className="table w-100">
                  <thead className="w-100">
                    <tr>
                      <th
                        style={dynamic_Table_Colors}
                        width="15%"
                        className={`both-top-border ${viewType === 'TabView' ? "thead_bottom_border" : ""}`}
                        rowSpan={2}
                      >
                        {this.lang("Part")}
                      </th>
                      <th rowSpan={2} className="empty_row"></th>
                      <th
                        rowSpan={2}
                        style={dynamic_Table_Colors}
                        width="7%"
                        className={`both-top-border ${viewType === 'TabView' ? "orange-col thead_bottom_border" : ""}`} >
                        {this.lang("plastic")}
                      </th>

                      <th rowSpan={2} className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        className={`both-top-border ${viewType === 'TabView' ? "light-gray-col" : ""}`}
                        colSpan={4}>
                        {this.lang("Size")}
                      </th>

                      {/* <td className="empty_row"></td> */}
                      {(ShowAW && viewType === 'TabView') && (
                        <>
                          <th className="empty_row"></th>
                          <th
                            rowSpan={2}
                            style={dynamic_Table_Colors}
                            width="7%"
                            className={`both-top-border ${viewType === 'TabView' ? "thead_bottom_border" : ""}`}
                          >
                            {this.lang("AW")}
                          </th>
                        </>
                      )}
                      <th rowSpan={2} className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        width="7%"
                        className={`both-top-border small_width_table ${viewType === 'TabView' ? "yellow-col" : ""}`}
                      >
                        {this.lang("PD")}
                      </th>
                      <th rowSpan={2} className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        className={`both-top-border small_width_table ${viewType === 'TabView' ? "orange-col" : ""}`}>
                        {this.lang("AL")}
                      </th>
                      <th rowSpan={2} className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        width="7%"
                        className={`both-top-border small_width_table ${viewType === 'TabView' ? "light-gray-col" : ""}`} >
                        {this.lang("PTP")}
                      </th>
                      <th rowSpan={2} className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        width="7%"
                        className={`both-top-border small_width_table ${viewType === 'TabView' ? "blue-col" : ""}`}>
                        {this.lang("WR")}
                      </th>
                      <th rowSpan={2} className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        width="7%"
                        className={`both-top-border small_width_table ${viewType === 'TabView' ? "green-col" : ""}`} >
                        {this.lang("DES")}
                      </th>
                      <th rowSpan={2} className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        width="7%"
                        className={`both-top-border small_width_table both-top-border ${viewType === 'TabView' ? "dark-gray-col" : ""}`}
                      >
                        {this.lang("RF")}
                      </th>

                      <th className="empty_row"></th>
                      {/* {viewType === 'TabView' && (
                        <th rowSpan={2}  style={{ width: "15%", minWidth: "130px" }} colSpan={2}>
                          <p>{this.lang("Replace")}</p>
                        </th>
                      )} */}
                      <th
                        style={dynamic_Table_Colors}
                        width="7%"
                        className={`both-top-border replace_french_column ${viewType === 'TabView' ? "green-col thead_bottom_border" : ""}`} rowSpan={2} >
                        {this.lang("Replace")}
                      </th>
                      {viewType === 'TabView' && isShowReplaceColumn && (<>
                        <th rowSpan={2} className="empty_row "></th>
                        <th
                          style={dynamic_Table_Colors}
                          width="7%"
                          className={`both-top-border replace_french_column check_mark_label ${viewType === 'TabView' ? "dark-gray-col thead_bottom_border" : ""}`} rowSpan={2} >
                          {this.lang("Replace")}
                        </th>
                      </>)}
                      <th rowSpan={2} className="empty_row "></th>
                      <th
                        style={dynamic_Table_Colors}
                        width="7%"
                        className={`small_width_table small_column_width both-top-border ${viewType === 'TabView' ? "orange-col thead_bottom_border" : ""}`}
                        rowSpan={2}>
                        {this.lang("TB")}
                      </th>
                      {ShowAW && (
                        <>
                          <th rowSpan={2} className="empty_row "></th>
                          <th
                            rowSpan={2}
                            style={dynamic_Table_Colors}
                            width="7%"
                            className="small_column_width both-top-border"
                          >
                            {this.lang("UT")}
                          </th>
                        </>
                      )}
                      <th rowSpan={2} className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        width="7%"
                        className={`both-top-border last_french_column ${viewType === 'TabView' ? "thead_bottom_border" : ""}`}
                        rowSpan={2}
                      >
                        {this.lang("amount€Excl.Tax")}
                      </th>
                    </tr>
                    <tr>
                      <th
                        style={dynamic_Table_Colors} className={`min-width-100 ${viewType === 'TabView' ? "light-gray-col thead_bottom_border" : ""}`}>
                        {this.lang("A")}
                      </th>
                      <th
                        style={dynamic_Table_Colors} className={`min-width-100 ${viewType === 'TabView' ? "light-gray-col thead_bottom_border" : ""}`}>
                        {this.lang("B")}
                      </th>
                      <th
                        style={dynamic_Table_Colors} className={`min-width-100 ${viewType === 'TabView' ? "light-gray-col thead_bottom_border" : ""}`}>
                        {this.lang("C")}
                      </th>
                      <th
                        style={dynamic_Table_Colors} className={`min-width-100 ${viewType === 'TabView' ? "light-gray-col thead_bottom_border" : ""}`} >
                        {this.lang("D")}
                      </th>
                      {(ShowAW && viewType === 'TabView') && (
                        <th rowSpan={2} className="empty_row"></th>
                      )}
                      <th
                        style={dynamic_Table_Colors} className={`${viewType === 'TabView' ? "yellow-col thead_bottom_border" : ""}`}>
                      </th>
                      <th
                        style={dynamic_Table_Colors} className={`${viewType === 'TabView' ? "orange-col thead_bottom_border" : ""}`}>
                        (+{parseFloat(ALUPercentage)}%)
                      </th>
                      <th
                        style={dynamic_Table_Colors} className={`${viewType === 'TabView' ? "light-gray-col thead_bottom_border" : ""}`}>
                        ({parseFloat(LAKPercentage)}%)
                      </th>
                      <th
                        style={dynamic_Table_Colors} className={`${viewType === 'TabView' ? "blue-col thead_bottom_border" : ""}`}>
                        (+{parseFloat(provideSheetMetal_percentage)}%)
                      </th>
                      <th
                        style={dynamic_Table_Colors} className={`${viewType === 'TabView' ? "green-col thead_bottom_border" : ""}`}>
                        (+50&euro;)
                      </th>
                      <th
                        style={dynamic_Table_Colors} className={`${viewType === 'TabView' ? "dark-gray-col thead_bottom_border" : ""}`}>
                      </th>
                      <th className="empty_row"></th>
                      {/* {viewType === "TabView" && <th className="text-center"></th>} */}
                    </tr>
                  </thead>
                  <tbody>
                    {data &&
                      data.map((row, index) => {
                        return (
                          row.Part !== "LeftFrontTyre" &&
                          row.Part !== "LeftBackTyre" &&
                          row.Part !== "RightFrontTyre" &&
                          row.Part !== "RightBackTyre" &&
                          row.Part !== "FrontBumper" &&
                          row.Part !== "BackBumper" &&
                          row.Part !== "Underbody" &&
                          row.Part !== "Inside" && (
                            <tr key={index}>
                              <td
                                style={dynamic_Table_Colors}
                                className="price-tbody-td"
                              >
                                <p className="table_text first_row"
                                  onClick={() =>
                                    viewType === "TabView" &&
                                    this.toggle(row.Part, true, row.Plastic)
                                  }
                                >
                                  {this.lang(row.Part === 'TrunkCover' ? 'Trunk' : row.Part === 'Trunk' ? 'TrunkCover' : row.Part)}
                                </p>
                              </td>
                              <td className="empty_row"></td>
                              <td className={`price-tbody-td ${viewType === 'TabView' ? "orange-col" : ""}`}
                                style={dynamic_Table_Colors}
                              >
                                {viewType === "TabView" ? (
                                  <input
                                    type="checkbox"
                                    className="cross_input"
                                    name="Plastic"
                                    checked={row.Plastic}
                                    onChange={(e) => {
                                      this.plasticChange(
                                        row.Part,
                                        e,
                                        index,
                                        "Plastic"
                                      );
                                    }}
                                    disabled={Authorized}
                                  />
                                ) : (
                                  row.Plastic && (<span style={{ fontSize: "15px" }}><i className='fa fa-check'></i></span>)
                                )}
                              </td>
                              <td className="empty_row"></td>
                              {/* A */}
                              <td
                                style={dynamic_Table_Colors}
                                className={`text_table_width price-tbody-td ${viewType === 'TabView' ? "light-gray-col" : ""}`}>
                                {viewType === 'TabView' ? (
                                  <div style={{ position: 'relative', width: '100%' }}>
                                    <input
                                      className="input_number"
                                      name="A"
                                      type="number"
                                      min="0"
                                      value={row.Plastic ? 0 : row.A}
                                      style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        textAlign: "center",
                                      }}
                                      onChange={(e) => !row.Plastic &&
                                        this.hadnleDentsChanges(e, index)
                                      }
                                      disabled={Authorized}
                                    />
                                    {!Authorized &&
                                      <>
                                        <div className="button-table-arrow-position">
                                          <button
                                            onClick={() => {
                                              const updatedValue = Math.max(row.A - 1, 0);
                                              this.hadnleDentsChanges({ target: { name: 'A', value: updatedValue } }, index);
                                            }}
                                            className="decrement-button"

                                          >
                                            -
                                          </button>
                                          <button
                                            onClick={() => {
                                              const updatedValue = row.A + 1;
                                              this.hadnleDentsChanges({ target: { name: 'A', value: updatedValue } }, index);
                                            }}
                                            className="increment-button"
                                          >
                                            +
                                          </button>
                                        </div>

                                      </>
                                    }
                                  </div>
                                ) : (
                                  <p className="table_text">{row.A}</p>
                                )}
                              </td>
                              {/* B */}
                              <td
                                style={dynamic_Table_Colors}
                                className={`text_table_width price-tbody-td ${viewType === 'TabView' ? "light-gray-col" : ""}`}>
                                {viewType === "TabView" ? (
                                  <div style={{ position: 'relative', width: '100%' }}>
                                    <input
                                      className="input_number"
                                      name="B"
                                      type="number"
                                      min="0"
                                      value={row.Plastic ? 0 : row.B}
                                      onChange={(e) => !row.Plastic &&
                                        this.hadnleDentsChanges(e, index)
                                      }
                                      style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        textAlign: "center",
                                      }}
                                      disabled={Authorized}
                                    />
                                    {!Authorized &&
                                      <>
                                        <div className="button-table-arrow-position">
                                          <button
                                            onClick={() => {
                                              const updatedValue = Math.max(row.B - 1, 0);
                                              this.hadnleDentsChanges({ target: { name: 'B', value: updatedValue } }, index);
                                            }}
                                            className="decrement-button"

                                          >
                                            -
                                          </button>
                                          <button
                                            onClick={() => {
                                              const updatedValue = row.B + 1;
                                              this.hadnleDentsChanges({ target: { name: 'B', value: updatedValue } }, index);
                                            }}
                                            className="increment-button"
                                          >
                                            +
                                          </button>
                                        </div>

                                      </>
                                    }
                                  </div>
                                ) : (
                                  <p className="table_text">{row.B}</p>
                                )}
                              </td>
                              {/* C */}
                              <td
                                style={dynamic_Table_Colors}
                                className={`text_table_width price-tbody-td ${viewType === 'TabView' ? "light-gray-col" : ""}`}>
                                {viewType === "TabView" ? (
                                  <div style={{ position: 'relative', width: '100%' }}>
                                    <input
                                      className="input_number"
                                      name="C"
                                      type="number"
                                      min="0"
                                      value={row.Plastic ? 0 : row.C}
                                      onChange={(e) => !row.Plastic &&
                                        this.hadnleDentsChanges(e, index)
                                      }
                                      style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        textAlign: "center",
                                      }}
                                      disabled={Authorized}
                                    />
                                    {!Authorized &&
                                      <>
                                        <div className="button-table-arrow-position">
                                          <button
                                            onClick={() => {
                                              const updatedValue = Math.max(row.C - 1, 0);
                                              this.hadnleDentsChanges({ target: { name: 'C', value: updatedValue } }, index);
                                            }}
                                            className="decrement-button"

                                          >
                                            -
                                          </button>
                                          <button
                                            onClick={() => {
                                              const updatedValue = row.C + 1;
                                              this.hadnleDentsChanges({ target: { name: 'C', value: updatedValue } }, index);
                                            }}
                                            className="increment-button"
                                          >
                                            +
                                          </button>
                                        </div>

                                      </>
                                    }
                                  </div>
                                ) : (
                                  <p className="table_text">{row.C}</p>
                                )}
                              </td>
                              {/* D */}
                              <td
                                style={dynamic_Table_Colors}
                                className={`text_table_width price-tbody-td ${viewType === 'TabView' ? "light-gray-col" : ""}`}>
                                {viewType === "TabView" ? (
                                  <div style={{ position: 'relative', width: '100%' }}>
                                    <input
                                      className="input_number"
                                      name="D"
                                      type="number"
                                      min="0"
                                      value={row.Plastic ? 0 : row.D}
                                      onChange={(e) => !row.Plastic &&
                                        this.hadnleDentsChanges(e, index)
                                      }
                                      style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        textAlign: "center",
                                      }}
                                      disabled={Authorized}
                                    />
                                    {!Authorized &&
                                      <>
                                        <div className="button-table-arrow-position">
                                          <button
                                            onClick={() => {
                                              const updatedValue = Math.max(row.D - 1, 0);
                                              this.hadnleDentsChanges({ target: { name: 'D', value: updatedValue } }, index);
                                            }}
                                            className="decrement-button"

                                          >
                                            -
                                          </button>
                                          <button
                                            onClick={() => {
                                              const updatedValue = row.D + 1;
                                              this.hadnleDentsChanges({ target: { name: 'D', value: updatedValue } }, index);
                                            }}
                                            className="increment-button"
                                          >
                                            +
                                          </button>
                                        </div>

                                      </>
                                    }
                                  </div>
                                ) : (
                                  <p className="table_text">{row.D}</p>
                                )}
                              </td>
                              {ShowAW && viewType === 'TabView' && (
                                <>
                                  <td className="empty_row"></td>
                                  <td
                                    style={dynamic_Table_Colors}
                                  >
                                    <p className="table_text">{row.Plastic ? 0 : this.getAW(row)}</p>
                                  </td>
                                </>
                              )}
                              {/* Presence of Non-Hail Damage */}
                              <td className="empty_row"></td>
                              <td
                                style={dynamic_Table_Colors}
                                className={`price-tbody-td ${viewType === 'TabView' ? "yellow-col" : ""}`}
                              >
                                {viewType === "TabView" ? (
                                  <input
                                    type="checkbox"
                                    className="cross_input"
                                    checked={row.Plastic ? false : row.NonHailDamagePresent}
                                    name="NonHailDamagePresent"
                                    onChange={(e) =>
                                      !row.Plastic &&
                                      this.handleAluLakChanges(
                                        e,
                                        index,
                                        "NonHailDamagePresent"
                                      )
                                    }
                                    disabled={Authorized}
                                  />
                                ) : (
                                  row.NonHailDamagePresent && (
                                    <span style={{ fontSize: "15px" }}>
                                      <i className='fa fa-check'></i>
                                    </span>
                                  )
                                )}
                              </td>
                              {/* ALU */}
                              <td className="empty_row"></td>
                              <td className={`price-tbody-td ${viewType === 'TabView' ? "orange-col" : ""}`}
                                style={dynamic_Table_Colors}
                              >
                                {viewType === "TabView" ? (
                                  <input
                                    type="checkbox"
                                    className="cross_input"
                                    checked={row.Plastic ? false : row.Alu}
                                    name="Alu"
                                    onChange={(e) =>
                                      !row.Plastic &&
                                      this.handleAluLakChanges(e, index, "Alu")
                                    }
                                    disabled={Authorized}
                                  />
                                ) : (
                                  row.Alu && (<span style={{ fontSize: "15px" }}><i className='fa fa-check'></i></span>)
                                )}
                              </td>
                              {/* PTP */}
                              <td className="empty_row"></td>
                              <td
                                style={dynamic_Table_Colors}
                                className={`price-tbody-td ${viewType === 'TabView' ? "light-gray-col" : ""}`}>
                                {viewType === "TabView" ? (
                                  <input
                                    type="checkbox"
                                    className="cross_input"
                                    checked={row.Plastic ? false : row.Push2paint}
                                    name="Push2paint"
                                    onChange={(e) =>
                                      !row.Plastic &&
                                      this.handleAluLakChanges(
                                        e,
                                        index,
                                        "Push2paint"
                                      )
                                    }
                                    disabled={Authorized}
                                  />
                                ) : (
                                  row.Push2paint && (<span style={{ fontSize: "15px" }}><i className='fa fa-check'></i></span>
                                  )
                                )}
                              </td>
                              {/* Sheet metal work to be planned */}
                              <td className="empty_row"></td>
                              <td
                                style={dynamic_Table_Colors}
                                className={`price-tbody-td ${viewType === 'TabView' ? "blue-col" : ""}`}>
                                {viewType === "TabView" ? (
                                  <input
                                    type="checkbox"
                                    className="cross_input"
                                    checked={row.Plastic ? false : row.ProvideSheetMetal}
                                    name="ProvideSheetMetal"
                                    onChange={(e) =>
                                      !row.Plastic &&
                                      this.handleAluLakChanges(
                                        e,
                                        index,
                                        "ProvideSheetMetal"
                                      )
                                    }
                                    disabled={Authorized}
                                  />
                                ) : (
                                  row.ProvideSheetMetal && (<span style={{ fontSize: "15px" }}><i className='fa fa-check'></i></span>)
                                )}
                              </td>
                              {/* Painting to be provided */}
                              <td className="empty_row"></td>
                              <td
                                style={dynamic_Table_Colors}
                                className={`price-tbody-td ${viewType === 'TabView' ? "green-col" : ""}`}>
                                {viewType === "TabView" ? (
                                  <input
                                    type="checkbox"
                                    className="cross_input"
                                    checked={row.Plastic ? false : row.disassemble}
                                    name="disassemble"
                                    onChange={(e) =>
                                      !row.Plastic &&
                                      this.handleAluLakChanges(
                                        e,
                                        index,
                                        "disassemble"
                                      )
                                    }
                                    disabled={Authorized}
                                  />
                                ) : (
                                  row.disassemble && (<span style={{ fontSize: "15px" }}><i className='fa fa-check'></i></span>)
                                )}
                              </td>
                              {/* /s réserve faisabilité */}
                              <td className="empty_row"></td>
                              <td
                                style={dynamic_Table_Colors}
                                className={`price-tbody-td ${viewType === 'TabView' ? "dark-gray-col" : ""}`}>
                                {viewType === 'TabView' ?
                                  <input
                                    type="checkbox"
                                    className="cross_input"
                                    checked={row.Plastic ? false : row.ReserveFeasibility}
                                    name="ReserveFeasibility"
                                    onChange={(e) => !row.Plastic &&
                                      this.handleAluLakChanges(
                                        e,
                                        index,
                                        "ReserveFeasibility"
                                      )
                                    }
                                    disabled={Authorized}
                                  />
                                  :
                                  row.ReserveFeasibility && (<span style={{ fontSize: "15px" }}><i className='fa fa-check'></i></span>)
                                }
                              </td>
                              <td className="empty_row"></td>

                              {/* Replace */}
                              <td
                                style={dynamic_Table_Colors}
                                className={`price-tbody-td ${viewType === 'TabView' ? "green-col" : ""}`}>
                                {viewType === 'TabView' ?
                                  <input
                                    type="checkbox"
                                    className="cross_input"
                                    checked={row.Plastic ? false : row.Replace}
                                    name="Replace"
                                    onChange={(e) =>
                                      !row.Plastic &&
                                      this.handleAluLakChanges(
                                        e,
                                        index,
                                        "Replace"
                                      )
                                    }
                                    disabled={Authorized}
                                  />
                                  :
                                  row.Replace && (<span style={{ fontSize: "15px" }}><i className='fa fa-check'></i></span>)
                                }
                              </td>
                              {/* Replace */}
                              {/* {viewType === "TabView" && (
                                <>
                                  <td className="text-center inner_line bottom_border_td">
                                    {row.arrAE &&
                                      row.arrAE.dataAE.length &&
                                      row.arrAE.dataAE.map((checkbox_val, i) => {
                                        return (
                                          <div
                                            className={`${
                                              row.arrAE.dataAE.length > 1 &&
                                              "bottom_border_span"
                                            }`}
                                          >
                                            <span key={i}>
                                              <input
                                                className="cross_input"
                                                type="checkbox"
                                                checked={
                                                  Array.isArray(data[index]["AE"]) &&
                                                  data[index]["AE"].includes(
                                                    checkbox_val
                                                  )
                                                    ? true
                                                    : false
                                                }
                                                onChange={(event) =>
                                                  this.changeAE(
                                                    event,
                                                    index,
                                                    checkbox_val
                                                  )
                                                }
                                                disabled={Authorized}
                                              />
                                            </span>
                                          </div>
                                        );
                                      })}
                                  </td>

                                  // ersetzen 
                                  <td className="inner_line replace_text">
                                    <div className="ae-content p-0">
                                      <div className="row p-0">
                                        {Array.isArray(
                                          row.arrAE && row.arrAE.dataAE
                                        ) &&
                                          row.arrAE.dataAE.map((checkbox_val, i) => {
                                              return (
                                                <Fragment key={i}>
                                                  <div
                                                    className={`${
                                                      row.arrAE.dataAE.length === 1
                                                        ? "col-lg-12 col-md-12 col-sm-12 p-0 d-flex text_main blank_border_width"
                                                        : "col-lg-12 col-md-12 col-sm-12 p-0 d-flex text_main"
                                                    }`}
                                                  >
                                                    <div className="row p-0">
                                                      <div className="col-12 p-0 ">
                                                        <p className="table_text">
                                                          {checkbox_val}
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </Fragment>
                                              );
                                            })}
                                      </div>
                                    </div>
                                  </td>
                                </>
                              )} */}
                              {viewType === "TabView" && isShowReplaceColumn && (
                                <>
                                  <td className="empty_row"></td>
                                  <td
                                    style={dynamic_Table_Colors}
                                    className={`price-tbody-td text-left ${this.props.viewType === "TabView" ? "dark-gray-col" : ""}`}
                                  >
                                    <div className="ae-content p-0">
                                      <div className="row p-0">
                                        {Array.isArray(row.arrErsetzen) &&
                                          row.arrErsetzen.map((checkbox_val) => {
                                            return (
                                              <>
                                                <div className="col-lg-12 col-md-12 col-sm-12 p-0 d-flex text-left">
                                                  <div className="alu_input_main">
                                                    <div className="alu_input_content">
                                                      <input
                                                        type="checkbox"
                                                        disabled={Authorized}
                                                        className="cross_input_table"
                                                        checked={
                                                          Array.isArray(
                                                            data[index]["Ersetzen"]
                                                          ) &&
                                                            data[index][
                                                              "Ersetzen"
                                                            ].includes(checkbox_val)
                                                            ? true
                                                            : false
                                                        }
                                                        onClick={(event) => {
                                                          this.changeErsetzen(
                                                            event,
                                                            index,
                                                            checkbox_val
                                                          )
                                                        }
                                                        }
                                                      />
                                                    </div>
                                                    <div className="alu_para_content">
                                                      <p className="p-0 m-0">{this.lang(checkbox_val)}</p>
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                            );
                                          })}
                                      </div>
                                    </div>
                                  </td>
                                </>
                              )}
                              {/* Total Dents */}
                              <td className="empty_row"></td>
                              <td
                                style={dynamic_Table_Colors}
                                className={`price-tbody-td ${viewType === 'TabView' ? "orange-col" : ""}`}>
                                <p className="table_text">
                                  {/* {(row.A ? row.A : 0) + (row.B ? row.B : 0) + (row.C ? row.C : 0) + (row.D ? row.D :  0) } */}
                                  {row.Plastic ? 0 : this.getParticularTotalDents(row)}
                                </p>
                              </td>

                              {/* Total UT */}
                              {ShowAW &&
                                <>
                                  <td className="empty_row"></td>
                                  <td
                                    style={dynamic_Table_Colors}
                                    className="text-center price-tbody-td">
                                    <p className="table_text">
                                      {this.getTotalUT(row, index)}
                                      {/* {`${this.getTotalUT(row, index)}(+${
                                      row.AWd ? row.AWd : 0
                                    } HG)`} */}
                                    </p>
                                  </td>
                                </>
                              }
                              {/* Montant */}
                              <td className="empty_row"></td>
                              <td
                                style={dynamic_Table_Colors}
                                className="text-right price-tbody-td">
                                <p className="table_text">
                                  {/* {this.getAluLakAddedAW(row, index)} */}
                                  {ShowPrice && this.getAmount(row, index, true)}
                                </p>
                              </td>
                            </tr>
                          )
                        );
                      })}
                  </tbody>
                  <tfoot>
                    <tr className="total-tr-table">
                      <th
                        style={dynamic_Table_Colors}
                        className={`both-bottom-border total-tr-table-th  ${viewType === 'TabView' ? "thead_top_border" : ""}`}
                      >
                        {this.lang("Total")}
                      </th>
                      <th className="empty_row"></th>
                      <>
                        <th
                          style={dynamic_Table_Colors}
                          className={`both-bottom-border ${viewType === 'TabView' ? "orange-col thead_top_border" : ""}`}></th>
                        <th className="empty_row"></th>

                      </>

                      <th
                        style={dynamic_Table_Colors}
                        className={`bottom-left-border total-tr-table-th ${viewType === 'TabView' ? "light-gray-col thead_top_border" : ""}`}
                      >
                        {data &&
                          data.reduce((acc, num) => {
                            if (
                              num.Part !== "LeftFrontTyre" &&
                              num.Part !== "LeftBackTyre" &&
                              num.Part !== "RightFrontTyre" &&
                              num.Part !== "RightBackTyre" &&
                              num.Part !== "FrontBumper" &&
                              num.Part !== "BackBumper" &&
                              num.Part !== "Underbody" &&
                              num.Part !== "Inside"
                            ) {
                              return parseFloat(acc) + parseFloat(num.Plastic ? 0 : num.A);
                            } else {
                              return parseFloat(acc);
                            }
                          }, 0)}
                      </th>
                      <th
                        style={dynamic_Table_Colors}
                        className={` total-tr-table-th ${viewType === 'TabView' ? "light-gray-col thead_top_border" : ""}`}>
                        {data &&
                          data.reduce((acc, num) => {
                            if (
                              num.Part !== "LeftFrontTyre" &&
                              num.Part !== "LeftBackTyre" &&
                              num.Part !== "RightFrontTyre" &&
                              num.Part !== "RightBackTyre" &&
                              num.Part !== "FrontBumper" &&
                              num.Part !== "BackBumper" &&
                              num.Part !== "Underbody" &&
                              num.Part !== "Inside"
                            ) {
                              return parseFloat(acc) + parseFloat(num.Plastic ? 0 : num.B);
                            } else {
                              return parseFloat(acc);
                            }
                          }, 0)}
                      </th>
                      <th
                        style={dynamic_Table_Colors}
                        className={` total-tr-table-th ${viewType === 'TabView' ? "light-gray-col thead_top_border" : ""}`}>
                        {data &&
                          data.reduce((acc, num) => {
                            if (
                              num.Part !== "LeftFrontTyre" &&
                              num.Part !== "LeftBackTyre" &&
                              num.Part !== "RightFrontTyre" &&
                              num.Part !== "RightBackTyre" &&
                              num.Part !== "FrontBumper" &&
                              num.Part !== "BackBumper" &&
                              num.Part !== "Underbody" &&
                              num.Part !== "Inside"
                            ) {
                              return parseFloat(acc) + parseFloat(num.Plastic ? 0 : num.C);
                            } else {
                              return parseFloat(acc);
                            }
                          }, 0)}
                      </th>
                      <th
                        style={dynamic_Table_Colors}
                        className={` total-tr-table-th bottom-right-border  ${viewType === 'TabView' ? "light-gray-col thead_top_border" : ""}`}>
                        {data &&
                          data.reduce((acc, num) => {
                            if (
                              num.Part !== "LeftFrontTyre" &&
                              num.Part !== "LeftBackTyre" &&
                              num.Part !== "RightFrontTyre" &&
                              num.Part !== "RightBackTyre" &&
                              num.Part !== "FrontBumper" &&
                              num.Part !== "BackBumper" &&
                              num.Part !== "Underbody" &&
                              num.Part !== "Inside"
                            ) {
                              return (
                                parseFloat(acc) + parseFloat(num.D ? num.Plastic ? 0 : num.D : 0)
                              );
                            } else {
                              return parseFloat(acc);
                            }
                          }, 0)}
                      </th>
                      {ShowAW && viewType === 'TabView' && (
                        <>
                          <th className="empty_row"></th>
                          <th
                            style={dynamic_Table_Colors}
                            className="total-tr-table-th both-bottom-border">
                            {data &&
                              data.reduce((acc, num) => {
                                if (
                                  num.Part !== "LeftFrontTyre" &&
                                  num.Part !== "LeftBackTyre" &&
                                  num.Part !== "RightFrontTyre" &&
                                  num.Part !== "RightBackTyre" &&
                                  num.Part !== "FrontBumper" &&
                                  num.Part !== "BackBumper" &&
                                  num.Part !== "Underbody" &&
                                  num.Part !== "Inside"
                                ) {
                                  return (
                                    parseFloat(acc) +
                                    parseFloat(num.AW ? num.Plastic ? 0 : num.AW : 0)
                                  );
                                } else {
                                  return parseFloat(acc);
                                }
                              }, 0)}
                          </th>
                        </>
                      )}
                      {/* <th colSpan={viewType === 'TabView' ?  8 : 6}></th> */}
                      <>
                        {viewType === "TabView" ? (
                          <>
                            <th className="empty_row"></th>
                            <th
                              style={dynamic_Table_Colors}
                              className={`both-bottom-border ${viewType === 'TabView' ? "yellow-col thead_top_border" : ""}`}
                            ></th>
                            <th className="empty_row"></th>
                            <th
                              style={dynamic_Table_Colors}
                              className={`${viewType === 'TabView' ? "orange-col both-bottom-border" : ""}`}
                            >
                            </th>
                            <th className="empty_row"></th>
                            <th
                              style={dynamic_Table_Colors}
                              className={`${viewType === 'TabView' ? "light-gray-col both-bottom-border" : ""}`}></th>
                            <th className="empty_row"></th>
                            <th
                              style={dynamic_Table_Colors}
                              className={`${viewType === 'TabView' ? "blue-col both-bottom-border" : ""}`}></th>
                            <th className="empty_row"></th>
                            <th
                              style={dynamic_Table_Colors}
                              className={`${viewType === 'TabView' ? "green-col both-bottom-border" : ""}`}></th>
                            <th className="empty_row"></th>
                            <th
                              style={dynamic_Table_Colors}
                              className={`both-bottom-border ${viewType === 'TabView' ? "dark-gray-col both-bottom-border" : ""}`}
                            ></th>
                            <th
                              style={dynamic_Table_Colors}
                              className="empty_row"></th>
                            <th
                              style={dynamic_Table_Colors}
                              className={`both-bottom-border ${viewType === 'TabView' ? "green-col both-bottom-border" : ""}`}></th>
                            {isShowReplaceColumn && ( 
                              <>
                                <th className="empty_row"></th>
                                <th
                                  style={dynamic_Table_Colors}
                                  className={`both-bottom-border ${viewType === 'TabView' ? "dark-gray-col both-bottom-border" : ""}`}></th>
                              </>
                            )}
                            {/* <th></th>
                            <th></th> */}
                          </>
                        ) : (
                          <>
                            <th className="empty_row"></th>
                            <th
                              style={dynamic_Table_Colors}
                              className="both-bottom-border"
                            >
                            </th>
                            <th className="empty_row"></th>
                            <th
                              style={dynamic_Table_Colors}
                              className="both-bottom-border"
                            >
                            </th>
                            <th className="empty_row"></th>
                            <th
                              style={dynamic_Table_Colors}
                              className="both-bottom-border"
                            ></th>
                            <th className="empty_row"></th>
                            <th
                              style={dynamic_Table_Colors}
                              className="both-bottom-border"
                            >
                            </th>
                            <th className="empty_row"></th>
                            <th style={dynamic_Table_Colors}
                              className="both-bottom-border"></th>
                            <th className="empty_row"></th>
                            <th style={dynamic_Table_Colors}
                              className="both-bottom-border"></th>
                            <th className="empty_row"></th>
                            <th style={dynamic_Table_Colors} className="both-bottom-border"></th>
                          </>
                        )}
                      </>
                      <th className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        className={`both-bottom-border ${viewType === 'TabView' ? "orange-col thead_top_border" : ""}`}>
                        {this.getTotalDents()}
                      </th>

                      {ShowAW &&
                        <>
                          <th className="empty_row"></th>
                          <th
                            style={dynamic_Table_Colors}
                            className="text-center both-bottom-border">
                            {this.totalUT()}
                          </th>
                        </>
                      }
                      <th className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        className="text-right both-bottom-border">
                        <table className="w-100 french_table_footer">
                          <tr>
                            <th
                              className="p-0 text-right"
                            >
                              {ShowPrice && <i className="fa fa-euro"></i>}
                            </th>
                            <th className="p-0 text-right">
                              {ShowPrice && `${this.getTotalAmount(true)}`}
                            </th>
                          </tr>
                        </table>
                      </th>
                    </tr>
                    <tr colSpan={15} className="empty_row empty_col"></tr>
                    {/* Price/hr */}
                    {/* Amount */}
                    <tr className="bottom-calculation-table-tr-wrapper bottom_calculation_row">
                      <th
                        style={dynamic_Table_Colors}
                        // colSpan={this.props.viewType === "TabView" ?  "10" : "10" }
                        colSpan={this.props.viewType === "TabView" ? "12" : "12"}
                        rowSpan={10}
                        className="without_border text-left bottom-footer-first-data-th"
                      >
                        <p className="table_text text_bold">
                          PD* <span>{this.lang("parkingDents")}</span>
                        </p>
                        <p className="table_text text_bold">
                          AL* <span>{this.lang("Alu")}</span>
                        </p>
                        <p className="table_text text_bold">
                          PTP* <span>{this.lang("Lak")}</span>
                        </p>
                        <p className="table_text text_bold">
                          WR* <span>{this.lang("bodyWork")}</span>
                        </p>
                        <p className="table_text text_bold">
                          DES* <span>{this.lang("disassemble")}</span>
                        </p>
                        <p className="table_text text_bold">
                          RF* <span>{this.lang("reserveFeasibility")}</span>
                        </p>
                        <p className="table_text text_bold">
                          TB* <span>{this.lang("Total Dents")}</span>
                        </p>
                      </th>
                      <th
                        style={dynamic_Table_Colors}
                        colSpan={colSpan}
                        className="text-right bottom-footer-ohher-data-th price-tbody-td">
                        {/* <p className="table_text">{this.lang("Amount")}</p> */}
                        {this.lang("Price/hr")}
                      </th>
                      <th className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        className="text-right bottom-footer-ohher-data-th price-tbody-td">
                        <table className="w-100 french_table_footer">
                          <tr>
                            <td className="p-0 text-left" style={{ fontWeight: "normal", border: 'none', fontSize: '14px', textAlign: "left" }}>
                              {ShowPrice && <i className="fa fa-euro"></i>}
                            </td>
                            <td className="min-width-100 input_arrow_style" style={{ border: "none", padding: 0, textAlign: "right" }}>
                              {/* <p className="table_text">{ShowPrice && this.getTotalAmount(true)}</p> */}
                              {viewType === "TabView" ? (
                                <div style={{ position: 'relative', width: '100%' }}>
                                  <input
                                    type="number"
                                    style={{
                                      width: "100%",
                                      border: "none",
                                      outline: "none",
                                      textAlign: "center",
                                    }}
                                    onChange={(e) => this.handleChange(e)}
                                    name="PricePerHour"
                                    value={ShowPrice && PricePerHour}
                                    min="0"
                                    step={1.0}
                                    disabled={Authorized}
                                  />
                                  {!Authorized &&
                                    <>
                                      <div className="button-table-arrow-position">
                                        <button
                                          onClick={() => {
                                            const updatedValue = Math.max((parseFloat(ShowPrice && PricePerHour) || 0) - 1, 0);
                                            this.handleChange({ target: { name: 'PricePerHour', value: updatedValue } });
                                          }}
                                          className="decrement-button"
                                          disabled={Authorized}
                                        >
                                          -
                                        </button>
                                        <button
                                          onClick={() => {
                                            const updatedValue = (parseFloat(ShowPrice && PricePerHour) || 0) + 1;
                                            this.handleChange({ target: { name: 'PricePerHour', value: updatedValue } });
                                          }}
                                          className="increment-button"
                                          disabled={Authorized}
                                        >
                                          +
                                        </button>
                                      </div>

                                    </>
                                  }
                                </div>
                              ) : (
                                <p className="table_text">
                                  {ShowPrice && `${Intl.NumberFormat("it-CH", { currency: "CHF", minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(PricePerHour.toFixed(2)).replace(".", ",")} €`}
                                </p>
                              )}
                            </td>
                          </tr>
                        </table>

                      </th>
                    </tr>
                    {/*Disassembling / Assembling Prices */}
                    <tr className="bottom-calculation-table-tr-wrapper bottom_calculation_row">
                      <th
                        style={dynamic_Table_Colors}
                        colSpan={colSpan}
                        className="text-right bottom-footer-ohher-data-th price-tbody-td">
                        <table className="french_table_footer">
                          <tr>
                            <td
                              className="text-right french-inner-table-text"
                              width="95%"
                            >
                              {this.lang("Disassembling / Assembling Prices")}
                            </td>
                            <td className="empty_row"></td>
                            <td
                              className="text-right french-inner-table-select"
                              width="5%"
                            >
                              {viewType === 'TabView' ?
                                <select
                                  onChange={(e) => this.handleChange(e)}
                                  placeholder="Select Car Type"
                                  name="CarType"
                                  value={CarType}
                                  style={{ border: "none", opacity: "1", color: "black" }}
                                  disabled={Authorized || viewType !== "TabView"}
                                >
                                  {/* <option value={''}>--Select--</option> */}
                                  {CarTypeArr.map((car) => (
                                    <option value={car.value}>
                                      {this.lang(car.label)}
                                    </option>
                                  ))}
                                </select>
                                :
                                <p className="table_text">
                                  {this.getCarOption()}
                                </p>
                              }
                            </td>
                          </tr>
                        </table>
                      </th>
                      <th className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        className="text-right bottom-footer-ohher-data-th price-tbody-td">
                        <table className="w-100 french_table_footer">
                          <tr>
                            <td className="p-0 text-left" style={{ fontWeight: "normal", border: 'none', fontSize: '14px', textAlign: "left" }}>
                              {ShowPrice && <i className="fa fa-euro"></i>}
                            </td>
                            <td style={{ border: "none", padding: 0, textAlign: "right" }}>
                              {(CarType === 'custom' && viewType === 'TabView') ?
                                <div style={{ position: 'relative', width: '100%' }}>
                                  <input
                                    type='number'
                                    style={{
                                      width: "100%",
                                      border: "none",
                                      outline: "none",
                                      textAlign: "right",
                                    }}
                                    name='customAssemblingPrices'
                                    value={!isUseBasePrice ? AssemblingPrices1 : AssemblingPrices2}
                                    onChange={(e) => this.handleChange(e)}
                                  />
                                  {!Authorized &&
                                    <>
                                      <div className="button-table-arrow-position">
                                        <button
                                          onClick={() => {
                                            const updatedValue = Math.max((parseFloat(!isUseBasePrice ? AssemblingPrices1 : AssemblingPrices2) || 0) - 1, 0);
                                            this.handleChange({ target: { name: 'customAssemblingPrices', value: updatedValue } });
                                          }}
                                          className="decrement-button"
                                          disabled={Authorized}
                                        >
                                          -
                                        </button>
                                        <button
                                          onClick={() => {
                                            const updatedValue = (parseFloat(!isUseBasePrice ? AssemblingPrices1 : AssemblingPrices2) || 0) + 1;
                                            this.handleChange({ target: { name: 'customAssemblingPrices', value: updatedValue } });
                                          }}
                                          className="increment-button"
                                          disabled={Authorized}
                                        >
                                          +
                                        </button>
                                      </div>

                                    </>
                                  }
                                </div>
                                :
                                <p className="table_text">
                                  {ShowPrice && `${Intl.NumberFormat("it-CH", { currency: "CHF", minimumFractionDigits: 2, maximumFractionDigits: 2, }).format((!isUseBasePrice ? AssemblingPrices1 : AssemblingPrices2) || 0).replace(".", ",")}`}
                                  {/* {ShowPrice && parseFloat(assemblingPrices).toFixed(2)} */}
                                </p>
                              }
                            </td>
                          </tr>
                        </table>

                      </th>
                    </tr>
                    {/* Disassembly / Reassembly Tailgate, Trunk / Boot (DSP) */}
                    <tr
                      className="bottom-calculation-table-tr-wrapper bottom_calculation_row">
                      <th colSpan={colSpan}
                        style={dynamic_Table_Colors}
                        className="text-right bottom-footer-ohher-data-th price-tbody-td">
                        {this.lang("Disassembly / Reassembly Tailgate, Trunk / Boot (DSP)")}
                      </th>
                      <th className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        className="text-right bottom-footer-ohher-data-th price-tbody-td">
                        <table className="w-100 french_table_footer">
                          <tr>
                            <td className="p-0 text-left" style={{ fontWeight: "normal", border: 'none', fontSize: '14px', textAlign: "left" }}>
                              {ShowPrice && <i className="fa fa-euro"></i>}
                            </td>
                            <td className="min-width-100 input_arrow_style" style={{ border: "none", padding: 0, textAlign: "right" }}>
                              {viewType === "TabView" ? (
                                <div style={{ position: 'relative', width: '100%' }}>
                                  <input
                                    type="number"
                                    style={{
                                      width: "100%",
                                      border: "none",
                                      outline: "none",
                                      textAlign: "center",
                                    }}
                                    min="0"
                                    onChange={(e) => this.handleChange(e)}
                                    name="DisassemblyReassemblyPart"
                                    step="1.00"
                                    value={ShowPrice && DisassemblyReassemblyPart}
                                    disabled={Authorized}
                                  />
                                  {!Authorized &&
                                    <div className="button-table-arrow-position">
                                      <button
                                        onClick={() => {
                                          const updatedValue = Math.max((parseFloat(ShowPrice && DisassemblyReassemblyPart) || 0) - 1, 0);
                                          this.handleChange({ target: { name: 'DisassemblyReassemblyPart', value: updatedValue } });
                                        }}
                                        className="decrement-button"
                                        disabled={Authorized}
                                      >
                                        -
                                      </button>
                                      <button
                                        onClick={() => {
                                          const updatedValue = (parseFloat(ShowPrice && DisassemblyReassemblyPart) || 0) + 1;
                                          this.handleChange({ target: { name: 'DisassemblyReassemblyPart', value: updatedValue } });
                                        }}
                                        className="increment-button"
                                        disabled={Authorized}
                                      >
                                        +
                                      </button>
                                    </div>
                                  }
                                </div>
                              ) : (
                                <p className="table_text">
                                  {ShowPrice && `${Intl.NumberFormat("it-CH", { currency: "CHF", minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(DisassemblyReassemblyPart.toFixed(2)).replace(".", ",")} €`}
                                  {/* {ShowPrice && parseFloat(DisassemblyReassemblyPart).toFixed(2)} */}
                                </p>
                              )}
                            </td>
                          </tr>
                        </table>

                      </th>
                    </tr>
                    {/* Disassembly / Reassembly - element to be replaced */}
                    <tr
                      style={dynamic_Table_Colors}
                      className="bottom-calculation-table-tr-wrapper bottom_calculation_row">
                      <th colSpan={colSpan} className="text-right bottom-footer-ohher-data-th price-tbody-td">
                        {this.lang(
                          "Disassembly / Reassembly - element to be replaced"
                        )}
                      </th>
                      <th className="empty_row"></th>
                      <th className="text-right bottom-footer-ohher-data-th price-tbody-td">
                        {/* {viewType === "TabView" ? (
                          <input
                            type="number"
                            style={{
                              width: "100%",
                              border: "none",
                              outline: "none",
                              textAlign: "right",
                            }}
                            min="0"
                            onChange={(e) => this.handleChange(e)}
                            name="DisassemblyReassemblyReplace"
                            value={ShowPrice && DisassemblyReassemblyReplace}
                            disabled={Authorized}
                          />
                        ) : (
                          <p className="table_text">
                          {ShowPrice &&  Intl.NumberFormat("it-CH", { currency: "CHF", minimumFractionDigits: 2, maximumFractionDigits: 2,}).format(DisassemblyReassemblyReplace.toFixed(2)).replace(".", ",")} 
                          </p>
                        )} */}

                        <table className="w-100 french_table_footer">
                          <tr>
                            <td className="p-0 text-right" style={{ fontWeight: "normal", border: 'none', fontSize: '14px', textAlign: "left" }}>
                              {ShowPrice && <i className="fa fa-euro"></i>}
                            </td>
                            <td style={{ border: "none", padding: 0, textAlign: "right" }}>
                              {ShowPrice && `${this.getTotalDisassemblyReassemblyReplace(true)}`}
                            </td>
                          </tr>
                        </table>
                      </th>
                    </tr>
                    {/* Estimated total Amount (1+2+3) */}
                    <tr
                      style={dynamic_Table_Colors}
                      className="bottom-calculation-table-tr-wrapper bottom_calculation_row">
                      <th colSpan={colSpan} className="text-right  bottom-left-border bottom-footer-ohher-data-th price-tbody-td">
                        {this.lang("estimatedTotalAmount")}
                      </th>
                      <th className="empty_row"></th>
                      <th className="text-right bottom-footer-ohher-data-th price-tbody-td bottom-right-border">
                        <table className="w-100 french_table_footer">
                          <tr>
                            <td className="p-0 text-right" style={{ fontWeight: "normal", border: 'none', fontSize: '14px', textAlign: "left" }}>
                              {ShowPrice && <i className="fa fa-euro"></i>}
                            </td>
                            <td style={{ border: "none", padding: 0, textAlign: "right" }}>
                              {ShowPrice && `${this.getTotalRepairCost(true)}`}
                            </td>
                          </tr>
                        </table>
                      </th>
                    </tr>
                  </tfoot>
                </table>
                {modal && (
                  <Lightbox
                    reactModalStyle={{
                      overlay: { zIndex: 100000000 },
                      content: {},
                    }}
                    mainSrc={
                      this.state.filteredImages.length > 0
                        ? `${this.state.filteredImages[this.state.currentImageIndex]}?t=${new Date().getTime()}` // Append timestamp
                        : require("../../assets/img/brand/dashboard-error-logo.png")
                    }
                    imageCaption={this.state.filteredImages.length > 0 && this.lang(
                      this.state.filteredImages[this.state.currentImageIndex]
                        .split('/')
                        .pop()
                        .replace(/^Report_/, '')
                        .replace(/_\d+\.jpg$/, '')
                    )}
                    nextSrc={
                      `${this.state.filteredImages[
                      (this.state.currentImageIndex + 1) % this.state.filteredImages.length
                      ]}?t=${new Date().getTime()}`
                    }
                    prevSrc={
                      `${this.state.filteredImages[
                      (this.state.currentImageIndex +
                        this.state.filteredImages.length -
                        1) % this.state.filteredImages.length
                      ]}?t=${new Date().getTime()}`
                    }
                    onCloseRequest={() => this.setState({ modal: false })}
                    onMovePrevRequest={() =>
                      this.setState({
                        currentImageIndex:
                          (this.state.currentImageIndex +
                            this.state.filteredImages.length -
                            1) %
                          this.state.filteredImages.length,
                      })
                    }
                    onMoveNextRequest={() =>
                      this.setState({
                        currentImageIndex:
                          (this.state.currentImageIndex + 1) %
                          this.state.filteredImages.length,
                      })
                    }
                    onImageLoadError={(...events) => console.log(events)}
                    imageLoadErrorMessage={
                      <img
                        style={{ height: "100%", width: "100%" }}
                        src={require("../../assets/img/brand/dashboard-error-logo.png")}
                      />
                    }
                  />
                )}
              </div>
            </div>
          }
          {this.props.is_extra_columns_visible_mini_fullreport && isShowReplaceColumn ?
            <div className="row report_tab_view_wrapper poland-replace-extra-page french_new_report_page">
              <div className="col-lg-12 p-0">
                <div className="table-responsive">
                  <table
                    width="100%"
                    className="table w-100"
                  // className=" table table-responsive-lg  w-100"
                  >
                    <thead>
                      <tr
                        width="100%"
                      >
                        <th
                          width="33%"
                          style={dynamic_Table_Colors}
                          className="both-top-border part-tr p-2"
                        >
                          {this.lang("Damage Description")}
                        </th>

                        <th className="empty_row"></th>
                        <th
                          width="33%"
                          style={dynamic_Table_Colors}
                          className="both-top-border ersetzen-tr row-replace p-2"
                        >
                          {this.lang('Replace')}
                        </th>
                      </tr>
                    </thead>
                    <tbody width="100%">
                      {Array.isArray(data) &&
                        data.map((row, index) => {
                          const unUsedParts = ["LeftFrontTyre", "LeftBackTyre", "RightFrontTyre", "RightBackTyre", "FrontBumper", "BackBumper", "Underbody", "Inside"];
                          if (unUsedParts.includes(row.Part)) {
                            return
                          }
                          return (
                            row.Part !== "LeftFrontTyre" && row.Part !== "LeftBackTyre" && row.Part !== "RightFrontTyre" && row.Part !== "RightBackTyre" && row.Part !== "FrontBumper" && row.Part !== "BackBumper" && row.Part !== "Underbody" && row.Part !== "Inside" &&
                            <tr className="" key={index}>
                              <td
                                className="price-tbody-td"
                                style={dynamic_Table_Colors}
                              >
                                <p className="p-0 m-0">{this.lang(row.Part)}</p>
                              </td>
                              <td className="empty_row"></td>
                              <td
                                className="price-tbody-td"
                                style={dynamic_Table_Colors}
                              >
                                <div className="ae-content p-0">
                                  <div className="row p-0">
                                    <div class="checkbox-grid-for-replace">
                                      {Array.isArray(row.arrErsetzen) &&
                                        row.arrErsetzen.map((checkbox_val) => {
                                          return (
                                            <>
                                              <div className="p-0 d-flex demo-flex-main">
                                                <div className="alu_input_main">
                                                  <div className="alu_input_content">
                                                    <input
                                                      className="cross_input_table"
                                                      type="checkbox"
                                                      disabled={Authorized}
                                                      checked={
                                                        Array.isArray(
                                                          data[index]["Ersetzen"]
                                                        ) &&
                                                          data[index][
                                                            "Ersetzen"
                                                          ].includes(checkbox_val)
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                  </div>
                                                  <div className="alu_para_content">
                                                    <p className="p-0 m-0">{this.lang(checkbox_val)}</p>
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          );
                                        })}
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                    <tfoot>
                      <tr
                        width="100%"
                      >
                        <th
                          width="30%"
                          style={dynamic_Table_Colors}
                          className="both-bottom-border part-tr"
                        >
                          {this.lang("Damage Description")}
                        </th>
                        <th className="empty_row"></th>
                        <th
                          width="35%"
                          style={dynamic_Table_Colors}
                          className="both-bottom-border ersetzen-tr row-replace"
                        >
                          {this.lang('Replace')}
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
            :
            null
          }
        </div>
      </>
    );
  }
}
const mapDispatchtoProps = (dispatch) => {
  return {
    getSelectedPartnerId: (show) => dispatch(getSelectedPartnerId(show)),
    updateJsonData: (show) => dispatch(updateJsonData(show)),
    reportAuthorized: (show) => dispatch(reportAuthorized(show)),
  };
};
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
    jsonData: props.jsonData,
    toggleReportDamageImage: props.toggleReportDamageImage
  };
};

export default connect(mapStateToProps, mapDispatchtoProps)(SwissFrenchPriceTable_v2);